// TODO - fold this into lib/urls

const imgHelper = (size) => (id) => id && id !== 0 ? `/photos/${id}/${size}.jpg` : `/images/${size}_no_image.png`;

export const photoMilli = imgHelper("milli");
export const photoCenti = imgHelper("centi");
export const photoProfile = imgHelper("profile");
export const photoSidebar = imgHelper("sidebar");
export const photoGear = imgHelper("gear");
export const photoMedium = imgHelper("medium");
export const photoLarge = imgHelper("large");
export const photoFull = imgHelper("full");

export const goalShow = (id) => `/goals/${id}`;
export const goalParticipant = (id) => `/goal_participants/${id}`;
